import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";

function Navbar() {
  return (
    <AppBar position="sticky" sx={{ bgcolor: "#52B2BF", color: "black" }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "bold" }}>
          Mohan Krishna Portfolio
        </Typography>
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Button sx={{ color: "black" }} href="#about">About</Button>
          <Button sx={{ color: "black" }} href="#skills">Skills</Button>
          <Button sx={{ color: "black" }} href="#projects">Projects</Button>
          <Button sx={{ color: "black" }} href="#resume">Resume</Button>
          <Button sx={{ color: "black" }} href="#contact">Contact</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
